import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './services/local-storage.service';
import { STORAGE_NAMES } from './shared/constants/constants';
import { TourStepTemplateComponent } from 'ngx-ui-tour-md-menu';

const { PRE_RELEASE, USER_LOCALE } = STORAGE_NAMES;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, TranslateModule, TourStepTemplateComponent],
})
export class AppComponent implements OnInit {
  previousUrl: string | null = null;
  currentUrl: string | null = null;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private localStorageService: LocalStorageService
  ) {
    translate.addLangs(['it', 'en']);
  }

  async ngOnInit(): Promise<any> {
    if (!this.localStorageService.getData(USER_LOCALE)) {
      this.localStorageService.setData(USER_LOCALE, environment.language);
    }
    if (!this.localStorageService.getData(PRE_RELEASE)) {
      this.localStorageService.setData(PRE_RELEASE, false);
    }
    this.translate.use(this.localStorageService.getData(USER_LOCALE));
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      });
  }
}
